import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import _ from "lodash";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Button from "react-bootstrap-button-loader";
import RichTextTinymceEditor from "RichTextTinymceEditor";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  fetchSettings,
  addSetting,
  updateSetting,
  fetchWizardStep,
  openTermsModal,
  updateTicketLiveStatus,
  checkTicketDaschoardStatus,
  updateEventSettingsTrackingPixel,
} from "TicketAction";
import { fetchEventDetails } from "DashboardUserAction";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import {
  COMMON_FAIL_MESSAGE,
  validateUrl,
  DOMAIN_NAME,
  DEVELOPMENT_TYPE,
  maxLengthObjectFc,
} from "Constants";
import DefaultTerms from "../setting/default_terms";
import Payout from "Payout";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};

// components
class Publish extends BaseComponent {
  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = {
      loading: false,
      checked: false,
      step1: false,
      step2: false,
      step3: false,
      eventsettings_id: null,
      thankyoupagetype: "",
      tracking: false,
      tracking_header_changed: false,
      tracking_header: "",
      tracking_footer_changed: false,
      tracking_footer: "",
    };
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);

    this.props.fetchSettings(this.props.session, (response) => {
      let settingData = response.data.resource ? response.data.resource : [];

      if (settingData && settingData.length > 0) {
        this.setState({
          checked: settingData[0].islive,
          eventsettings_id: settingData[0].id,
        });

        if (!_.isEmpty(settingData[0].trackingpixel)) {
          let local_trackingPixel = JSON.parse(settingData[0].trackingpixel);
          this.setState({ tracking_header: local_trackingPixel.header });
          this.setState({ tracking_footer: local_trackingPixel.footer });
        }
      }
    });
  }

  openModel = (field) => {
    this.props.openTermsModal({ showModal: true, open: field });
  };

  onSubmitForm(values) {
    var data;

    if (values.thankyoutype == "link") {
      values.thankyoulink = values.thankyoulink;
    } else {
      values.thankyoulink = null;
    }
    if (values.thankyoutype == "text") {
      values.congratulations = values.congratulations;
    } else {
      values.congratulations = null;
    }

    data = { ...values };

    this.setState({ loading: true });
    if (this.props.editMode) {
      this.props.updateSetting(data, this.props.session, (response) => {
        // console.log('response',response);
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.tickets_setting_form_setting_updated_success
          );
          this.props.reset();
          this.props.checkTicketDaschoardStatus(this.props.session);
        }
      });
    } else {
      this.props.addSetting(this.props.session, data, (response) => {
        // console.log('response',response);
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.tickets_setting_form_setting_added_success
          );
          this.props.reset();
          this.props.checkTicketDaschoardStatus(this.props.session);
        }
      });
    }
  }

  renderFieldText(field) {
    var { labelposition } = field;
    var divClassName = `row form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        {field.label == "Tax Percentage" ? (
          <label className={labelClasses}>
            {field.label}{" "}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>{" "}
            <span style={{ fontSize: 10 }}>
              (
              {LocaleStrings.tickets_setting_text_tax_will_apply_on_all_tickets}
              )
            </span>
          </label>
        ) : (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        )}
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
            max={field.max ? field.max : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderCustomSelect(field) {
    var divClassName = `row form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        <label className="control-label-top col-sm-12">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className="col-sm-12 col-sm-offset-0">
          <select className="form-control" {...field.input}>
            <option value="" key={field.label}>
              {field.placeholder}
            </option>
            {field.opts.map((object, index) => {
              return (
                <option key={`${object.value}-${index}`} value={object.value}>
                  {object.name}
                </option>
              );
            })}
          </select>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderTicketSettingCheckbox(field) {
    var divClassName = `row form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        <div className="col-md-12">
          <label className="custom-container-checkbox mb-0">
            <input className="" type={field.type} {...field.input} />
            <span className="checkmark" />
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
            <a
              href="https://eventify.io/terms-of-use/"
              target="blank"
              style={{ float: "right", fontWeight: 700 }}
            >
              {
                LocaleStrings.tickets_setting_text_read_eventify_terms_conditions
              }
            </a>
            <div className="text-help label-text-help">
              {field.meta.touched ? field.meta.error : ""}
            </div>
          </label>
        </div>
      </div>
    );
  }

  renderRichTextareaWithLabel(field) {
    var divClassName = `row form-group ${field.meta.error ? "has-danger" : ""}`;
    divClassName = `${divClassName}`;

    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
          {field.url ? (
            <a className="ml-10" href={field.url} target="_blank">
              {field.url}
            </a>
          ) : (
            ""
          )}
          <a
            onClick={() => field.onClick(field.input.name)}
            className="custom-a-tag"
            style={{ float: "right" }}
          >
            {LocaleStrings.tickets_setting_form_text_sample_template}
          </a>
        </label>

        <div className={inputClasses}>
          <RichTextTinymceEditor type={field.type} {...field} />
          <div className="text-help label-text-help">
            {field.meta.error ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  changeMode(checked) {
    //this.setState({checked:!checked });
  }

  changeTicketLiveMode = () => {
    let { settingData, ticketDashboard } = this.props;
    let status = 1;
    let id = settingData[0].id;
    if (settingData && settingData.length > 0 && settingData[0].islive) {
      status = 0;
    }

    if (ticketDashboard && ticketDashboard.ticket && ticketDashboard.setting) {
      this.props.updateTicketLiveStatus(
        this.props.session,
        status,
        id,
        (response) => {
          if (response.success) {
            this.props.fetchSettings(this.props.session);
          }
        }
      );
    } else {
      this.props.showError(LocaleStrings.wizard_publish_error_text);
    }
  };

  toggleStep(current, old) {
    //console.log('current',current);
    let currentStep = this.state[current];
    //console.log('currentStep',currentStep);
    this.setState({ [current]: !currentStep, [old]: false });
  }

  handleThankPagetype = (type) => {
    // console.log("type :- ", type);

    this.setState({ thankyoupagetype: type });
  };

  handleTrackingToggle = () => {
    const {
        tracking,
        tracking_header,
        tracking_footer,
        tracking_header_changed,
        tracking_footer_changed,
        eventsettings_id,
      } = this.state,
      { session, eventDetails } = this.props;

    // update eventsettings tracingpixel field
    if (tracking && (tracking_header_changed || tracking_footer_changed)) {
      let update_json = {
        header: tracking_header,
        footer: tracking_footer,
      };

      this.props.updateEventSettingsTrackingPixel(
        session,
        eventsettings_id,
        update_json,
        (res) => {
          this.setState({
            tracking_header_changed: false,
            tracking_footer_changed: false,
          });
          if (res.success) {
            let local_res = JSON.parse(res.data.trackingpixel);
            this.setState({
              checked: res.data.islive,
              tracking_header: local_res.header,
              tracking_footer: local_res.footer,
            });
          }
        }
      );
    } else {
      this.props.autofill("ticket_tracking_header", tracking_header);
      this.props.autofill("ticket_tracking_footer", tracking_footer);
    }

    // toogle
    this.setState({ tracking: !tracking });
  };

  render() {
    const {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      editMode,
      initialValues,
      WizardStep,
      settingData,
      eventDetails,
      ticketDashboard,
    } = this.props;
    //console.log('checked',this.state.checked);
    let refundPolicy = [
      {
        name: "1 day: Attendees can receive refunds upto 1 day before the event start date",
        value: "1 day",
      },
      {
        name: "7 days: Attendees can receive refunds upto 7 days before the event start date",
        value: "7 days",
      },
      {
        name: "30 days: Attendees can receive refunds upto 30 days before the event start date",
        value: "30 days",
      },
      { name: "No refunds: We do not offer refunds", value: "No refunds" },
    ];

    let listingPrivacy = [
      { name: "Public", value: "public" },
      { name: "Private", value: "private" },
    ];

    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";
    var ticketUrl = `https://${seocode}.${DOMAIN_NAME}/t/tickets`;

    var termsconditionurl = eventDetails
      ? `https://${seocode}.${DOMAIN_NAME}/t/tickets/terms-conditions`
      : "";
    var privacypolicyurl = eventDetails
      ? `https://${seocode}.${DOMAIN_NAME}/t/tickets/privacy-policy`
      : "";

    let ticketValidationStyle = "steps-icon-not-filled";
    let stripeValidationStyle = "steps-icon-not-filled";
    let settingValidationStyle = "steps-icon-not-filled";

    let ticketIcon = "fa fa-exclamation-circle";
    let stripeIcon = "fa fa-exclamation-circle";
    let settingIcon = "fa fa-exclamation-circle";

    if (ticketDashboard && ticketDashboard.ticket) {
      ticketValidationStyle = "steps-icon-filled";
      ticketIcon = "fa fa-check-circle";
    }
    if (ticketDashboard && ticketDashboard.paymentgateway) {
      stripeValidationStyle = "steps-icon-filled";
      stripeIcon = "fa fa-check-circle";
    }
    if (ticketDashboard && ticketDashboard.setting) {
      settingValidationStyle = "steps-icon-filled";
      settingIcon = "fa fa-check-circle";
    }

    // tracking toggler
    let trackingStyle = "fa fa-chevron-circle-down";
    let trackingActive = "";
    if (this.state.tracking) {
      trackingStyle = "fa fa-chevron-circle-up";
      trackingActive = "activeup";
    }

    let step1 = "fa fa-chevron-circle-down";
    let step1active = "steps-icon-arrow";
    if (this.state.step1) {
      step1 = "fa fa-chevron-circle-up";
      step1active = "steps-icon-arrow activeup";
    }

    let step2 = "fa fa-chevron-circle-down";
    let step2active = "steps-icon-arrow";
    if (this.state.step2) {
      step2 = "fa fa-chevron-circle-up";
      step2active = "steps-icon-arrow activeup";
    }

    var thankyoupagetype =
      this.state.thankyoupagetype != ""
        ? this.state.thankyoupagetype
        : initialValues.thankyoutype;

    return (
      <div style={{ width: "70%" }}>
        {DEVELOPMENT_TYPE === "koachify" ? (
          ""
        ) : (
          <div className="row">
            <div className="col-md-12">
              {/* ----- Ticket page copy/visit - Tracking code manage ----- */}
              <div className="ticket-dashboard-ticket-created-page-main-div">
                {/* --- Title --- */}
                <h4 className="heading-para">
                  {LocaleStrings.tickets_dashboard_text_ticket_page_created}
                </h4>
                {/* --- Subtitle --- */}
                <p className="promote-para">
                  {
                    LocaleStrings.tickets_dashboard_text_ticket_page_created_sub_title
                  }
                </p>
                {/* --- Copy visit component --- */}
                <div className="vertical-align-center gap-2">
                  <div className="">
                    <div className="copy-ticket-page">
                      <div className="ticket-url">{ticketUrl}</div>
                      <CopyToClipboard text={ticketUrl} onCopy={this.copyUrl}>
                        <div className="url-copy">
                          <i className="fa fa-files-o" aria-hidden="true"></i>
                          &nbsp;{LocaleStrings.button_copy}
                        </div>
                      </CopyToClipboard>
                    </div>
                    {this.state.copied ? (
                      <span style={{ color: "black", float: "right" }}>
                        {LocaleStrings.copied}.
                      </span>
                    ) : null}
                  </div>
                  <div className="">
                    <a
                      href={ticketUrl}
                      target="blank"
                      className="btn btn-custom-blue"
                    >
                      <span aria-hidden="true">
                        {LocaleStrings.button_visit}
                      </span>
                    </a>
                  </div>
                </div>

                {/* --- Tracking code manage --- */}
                <div
                  className="dashboard-steps"
                  data-data_id="Step1"
                  onClick={this.handleTrackingToggle}
                  style={{ display: "flex", padding: "16px 0 0" }}
                >
                  <div style={{ width: "93%" }}>
                    <h6 className="label-mandatory">
                      {
                        LocaleStrings.tickets_dashboard_trackingpixel_caution_text
                      }
                    </h6>
                  </div>
                  <div className={trackingActive} style={{ fontSize: 24 }}>
                    <i className={trackingStyle} aria-hidden="false"></i>
                  </div>
                </div>
                {this.state.tracking ? (
                  <div className="row">
                    <div className="col-md-12">
                      <Field
                        name="ticket_tracking_header"
                        label={
                          LocaleStrings.tickets_ticket_form_label_trackingpixel_header
                        }
                        placeholder={
                          LocaleStrings.tickets_ticket_form_ph_trackingpixel
                        }
                        component={this.renderFieldTextarea}
                        labelposition={LABEL_POSITION_TOP}
                        value={this.state.tracking_header}
                        onChange={(e) => {
                          this.setState({
                            tracking_header_changed: true,
                            tracking_header: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="col-md-12">
                      <Field
                        name="ticket_tracking_footer"
                        label={
                          LocaleStrings.tickets_ticket_form_label_trackingpixel_footer
                        }
                        placeholder={
                          LocaleStrings.tickets_ticket_form_ph_trackingpixel
                        }
                        component={this.renderFieldTextarea}
                        labelposition={LABEL_POSITION_TOP}
                        value={this.state.tracking_footer}
                        onChange={(e) => {
                          this.setState({
                            tracking_footer_changed: true,
                            tracking_footer: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="col-md-12 control-label-top">
                      <label className="control-label-top">
                        {LocaleStrings.tickets_trackingpixel_cautionary_text}
                      </label>
                    </div>
                    <div className="col-md-12">
                      <Button
                        style={{ marginTop: 10, marginRight: 15 }}
                        className="button-theme button-theme-blue pull-right"
                        bsStyle="primary"
                        type="button"
                        onClick={this.handleTrackingToggle}
                      >
                        {LocaleStrings.button_save}
                      </Button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>

              {/* ----- Ticket sale toggler ----- */}
              <div className="ticket-dashboard-ticket-sell-main-div">
                {this.state.checked ? (
                  <div className="sell-text-checked">
                    <h4 className="heading-para">
                      {
                        LocaleStrings.tickets_dashboard_text_ticket_is_live_title
                      }
                      .
                    </h4>
                    <div className="description-para">
                      {
                        LocaleStrings.tickets_dashboard_text_ticket_is_live_subtitle
                      }
                      .
                    </div>
                  </div>
                ) : (
                  <div className="sell-text-unchecked">
                    <h4 className="heading-para">
                      {LocaleStrings.wizard_text_ticket_is_off_title}.
                    </h4>
                    <p className="description-para">
                      {LocaleStrings.wizard_text_ticket_is_off_subtitle}.
                    </p>
                  </div>
                )}
                <div className="sell-action">
                  <label className="switch-button-container">
                    <input
                      type="checkbox"
                      onChange={this.changeTicketLiveMode}
                      checked={this.state.checked}
                    />
                    <span className="switch-slider switch-round"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="row mt-15">
          <div className="col-md-12">
            <div>
              {
                LocaleStrings.tickets_dashboard_text_things_to_do_for_ticket_sell
              }
            </div>
            <div className="ticket-dashboard-steps-main-div custom-ticket-wizard-publish-things-to-do">
              <div
                className="dashboard-steps"
                data-data_id="Step1"
                onClick={() => this.toggleStep("step1", "step2")}
              >
                <div className={stripeValidationStyle}>
                  <i className={stripeIcon} aria-hidden="true"></i>
                </div>
                <div style={{ width: "88%" }}>
                  <h4 className="heading-para">
                    {LocaleStrings.tickets_dashboard_text_connect_with_stripe}!
                  </h4>
                  <p className="description-para">
                    {
                      LocaleStrings.tickets_dashboard_text_connect_with_stripe_sub_title
                    }
                    .
                  </p>
                </div>
                <div className={step1active}>
                  <i className={step1} aria-hidden="false"></i>
                </div>
              </div>
              {this.state.step1 ? (
                <div className="row">
                  <div className="col-md-12">
                    <Payout callfrom="wizard" />
                  </div>
                </div>
              ) : (
                ""
              )}

              <div
                className="dashboard-steps"
                data-data_id="Step2"
                onClick={() => this.toggleStep("step2", "step1")}
              >
                <div className={settingValidationStyle}>
                  <i className={settingIcon} aria-hidden="true"></i>
                </div>
                <div style={{ width: "88%" }}>
                  <h4 className="heading-para">
                    {LocaleStrings.tickets_dashboard_text_complete_setting}!
                  </h4>
                  <p className="description-para">
                    {
                      LocaleStrings.tickets_dashboard_text_complete_setting_sub_title
                    }
                    .
                  </p>
                </div>
                <div className={step2active}>
                  <i className={step2} aria-hidden="false"></i>
                </div>
              </div>

              {this.state.step2 ? (
                <div>
                  <DefaultTerms />

                  <form onSubmit={handleSubmit(this.onSubmitForm)}>
                    <div className="row">
                      <div className="col-md-12">
                        <label className="setting-company-section-heading">
                          {
                            LocaleStrings.tickets_setting_form_terms_conditions_group
                          }
                        </label>
                        <hr className="hr-custom-new" />
                        <Field
                          name="refundpolicy"
                          label={
                            LocaleStrings.tickets_setting_form_label_refund_policy
                          }
                          placeholder={
                            LocaleStrings.tickets_setting_form_ph_refund_policy
                          }
                          type="select"
                          mandatory="true"
                          component={this.renderCustomSelect}
                          opts={refundPolicy}
                        />

                        <Field
                          name="privacy"
                          label={
                            LocaleStrings.tickets_setting_form_label_privacy_policy
                          }
                          placeholder={
                            LocaleStrings.tickets_setting_form_ph_privacy_policy
                          }
                          mandatory="true"
                          type="minimal"
                          component={this.renderRichTextareaWithLabel}
                          url={privacypolicyurl}
                          onClick={this.openModel}
                          height={300}
                        />

                        <Field
                          name="termsandconditions"
                          label={
                            LocaleStrings.tickets_setting_form_label_terms_conditions
                          }
                          placeholder={
                            LocaleStrings.tickets_setting_form_ph_terms_conditions
                          }
                          mandatory="true"
                          type="minimal"
                          component={this.renderRichTextareaWithLabel}
                          url={termsconditionurl}
                          onClick={this.openModel}
                          height={300}
                        />

                        <Field
                          name="eventify_terms"
                          label={
                            LocaleStrings.tickets_setting_form_label_eventify_terms_conditions
                          }
                          type="checkbox"
                          mandatory="true"
                          component={this.renderTicketSettingCheckbox}
                        />

                        <label className="setting-company-section-heading">
                          {
                            LocaleStrings.tickets_setting_form_organization_corner_group
                          }
                        </label>
                        <hr className="hr-custom-new" />

                        <div className="mb-20">
                          <label
                            className="control-label-top m-0 mb-5"
                            style={{ padding: 0 }}
                          >
                            {
                              LocaleStrings.tickets_setting_form_label_thankyou_page_type
                            }
                            <span className="label-mandatory">*</span>
                          </label>
                          <div
                            className="col-md-12"
                            style={{ padding: 0, display: "flex" }}
                          >
                            <Field
                              name="thankyoutype"
                              label={
                                LocaleStrings.tickets_setting_form_text_thankyou_option1
                              }
                              component={this.renderFieldRadio}
                              type="radio"
                              value="text"
                              onChange={() => this.handleThankPagetype("text")}
                            />{" "}
                            <Field
                              name="thankyoutype"
                              label={
                                LocaleStrings.tickets_setting_form_text_thankyou_option2
                              }
                              component={this.renderFieldRadio}
                              type="radio"
                              value="link"
                              onChange={() => this.handleThankPagetype("link")}
                            />
                          </div>
                        </div>
                        {thankyoupagetype == "link" ? (
                          <Field
                            name="thankyoulink"
                            label={
                              LocaleStrings.tickets_setting_form_label_thankyou_link
                            }
                            placeholder={
                              LocaleStrings.tickets_setting_form_ph_thankyou_link
                            }
                            type="text"
                            mandatory="true"
                            component={this.renderFieldText}
                          />
                        ) : (
                          <Field
                            name="congratulations"
                            label={
                              LocaleStrings.tickets_setting_form_label_congratulation_message
                            }
                            placeholder={
                              LocaleStrings.tickets_setting_form_ph_congratulation_message
                            }
                            type="minimal"
                            mandatory="true"
                            component={this.renderRichTextareaWithLabel}
                            onClick={this.openModel}
                            height={300}
                          />
                        )}
                        {/* <div className="row" style={{margin: 0}}>
                            <div className="col-md-12 sessing-page"> 
                                <div className="form-group">
                                    <label className="control-label-top col-sm-3">{LocaleStrings.tickets_dashboard_text_ticket_is_live}.</label>
                                    <div className="col-sm-6 col-sm-offset-0 sell-action">
                                        <label className="switch-button-container">
                                            
                                            <input type="checkbox" onchange={()=>this.changeMode(this.state.checked)}  checked={this.state.checked}  />
                                            
                                            <span className="switch-slider switch-round"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>    
                        </div> */}

                        <Button
                          style={{ marginTop: 10, marginRight: 15 }}
                          className="button-theme button-theme-blue pull-right"
                          bsStyle="primary"
                          loading={this.state.loading}
                          disabled={pristine || invalid || submitting}
                          type="submit"
                        >
                          {LocaleStrings.button_save}
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var initVals = { refundpolicy: "No refunds", thankyoutype: "text" };
  var toEdit = false;

  if (
    state.SettingData &&
    state.SettingData.resource &&
    state.SettingData.resource.length > 0
  ) {
    initVals = state.SettingData.resource[0];
    if (state.SettingData.resource[0].tax == "0") {
      initVals.tax = "";
    }
    if (
      !state.SettingData.resource[0].refundpolicy ||
      state.SettingData.resource[0].refundpolicy == ""
    ) {
      initVals.refundpolicy = "No refunds";
    }
    initVals.thankyoutype =
      state.SettingData.resource[0].thankyoulink &&
      state.SettingData.resource[0].thankyoulink != ""
        ? "link"
        : "text";

    toEdit = true;
  }

  return {
    session: state.session,
    initialValues: initVals,
    editMode: toEdit,
    WizardStep: state.WizardStep,
    settingData: state.SettingData.resource,
    eventDetails: state.userEventDetails,
    ticketDashboard: state.ticketDashboard.data,
  };
}

function validate(values) {
  var errors = {};
  var refundpolicy = values["refundpolicy"];
  var listingprivacy = values["listingprivacy"];
  var privacy = values["privacy"];
  var termsandconditions = values["termsandconditions"];
  var thankyoutype = values["thankyoutype"];
  var thankyoulink = values["thankyoulink"];
  var congratulations = values["congratulations"];
  var eventify_terms = values["eventify_terms"];

  if (!refundpolicy) {
    errors["refundpolicy"] =
      LocaleStrings.tickets_setting_form_validation_required;
  }

  // if(!listingprivacy){
  //   errors['listingprivacy'] = LocaleStrings.tickets_setting_form_validation_required;
  // }

  if (!privacy || privacy.trim() === "") {
    errors["privacy"] = LocaleStrings.tickets_setting_form_validation_required;
  }

  if (!termsandconditions || termsandconditions.trim() === "") {
    errors["termsandconditions"] =
      LocaleStrings.tickets_setting_form_validation_required;
  }

  if (
    thankyoutype == "text" &&
    (!congratulations || congratulations.trim() === "")
  ) {
    errors["congratulations"] =
      LocaleStrings.tickets_setting_form_validation_required;
  } else if (thankyoutype == "link") {
    if (!thankyoulink || thankyoulink.trim() == "")
      errors["thankyoulink"] =
        LocaleStrings.tickets_setting_form_validation_required;
    else if (thankyoulink && !validateUrl(thankyoulink))
      errors["thankyoulink"] = LocaleStrings.invalid_url;
  }

  if (!eventify_terms) {
    errors["eventify_terms"] =
      LocaleStrings.tickets_setting_form_validation_required;
  }

  if (values["congratulations"] && MAXLENOBJ) {
    if (
      values["congratulations"].replace(/<[^>]+>/g, "").replace("&nbsp;", "")
        .length > MAXLENOBJ.congratulations
    ) {
      errors["congratulations"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.congratulations;
    }
  }

  return errors;
}

export default connect(mapStateToProps, {
  fetchSettings,
  addSetting,
  updateSetting,
  showError,
  showSuccess,
  fetchWizardStep,
  openTermsModal,
  fetchEventDetails,
  updateTicketLiveStatus,
  checkTicketDaschoardStatus,
  updateEventSettingsTrackingPixel,
})(
  reduxForm({
    validate,
    form: "PublishForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Publish)
);
